export type ReceivedProps = Record<string, any>;

const useBusinessManualsCategoryStatus = (props: ReceivedProps) => {
  return {
    ...props,
  };
};

export type Props = ReturnType<typeof useBusinessManualsCategoryStatus>;

export default useBusinessManualsCategoryStatus;
